module.exports = __webpack_public_path__ + "static/media/ritsu_activeac8c85f3c0fa537c575b5bce1edd8f3d.webp";